<template>
	<div class="recom-container">
		<h2 class="h2-title">Рекомендации</h2>
		<p v-if="comment >= 2" class="recom-comment">Вот это результат! У тебя ярко выражены несколько типов интеллекта! Почитай наши рекомендации и в следующих этапах конкурса используй тот тип, который поможет тебе справиться с заданиями лучше всех.</p>
		<div class="flex">
			<ul class="recom-list">
				<li v-for="(item, i) in data" :key="i" class="recom-list-item">
					<RecommendationItem :title="item.title" :single="item.single"/>
				</li>
			</ul>
		</div>
	</div>
</template>
<style lang="css">
	.recom-container {
		position: relative;
		background-image: url("https://storage.yandexcloud.net/proektoria-education/static/images/recom-bottom.svg");
		background-repeat: no-repeat;
		background-position: bottom;
		background-size: 100%;
		background-color: #fff;
		padding-bottom: 55px;
		border-radius: 4px;
	}

	.recom-container:after {
		content: '';
		display: block;
		position: absolute;
		right: 0;
		bottom: 0;
		width: 208px;
		height: 217px;
		background: url("https://storage.yandexcloud.net/proektoria-education/static/images/recom-person.png");
		background-size: 100%;
	}

	.recom-list {
		padding: 0;
		list-style: none;
		padding-right: 208px;
	}

	.recom-comment {
		margin-bottom: 16px;
	}

	.recom-list-item {
		margin-bottom: 24px;
	}

	@media (max-width: 768px) {
		.recom-list {
			padding-right: 0;
		}

		.recom-container {
			padding-bottom: 220px !important;
		}
	}
</style>
<script>
	import RecommendationItem from "./RecommendationItem";

	export default {
		props: {
			comment: {
				type: Number,
				default: 0,
				required: false,
			},
			data: {
				type: Array,
				default: () => {
					return []
				},
				required: true,
			}
		},
		components: {
			RecommendationItem
		},
		data() {
			return {
				isOpen: false,
			}
		},
		methods: {
			open() {
				this.isOpen = !this.isOpen;
			}
		}
	}
</script>
